import { Building2, Globe } from "lucide-react";

import { ColocaBadge } from "@/shared/components/data-display/ColocaBadge";
import { useTranslations } from "@/shared/lang/useTranslations";

export interface AccessScopeBadgeProps {
  /** `null`/undefined ⇒ global (Coloca-owned); a value ⇒ org-scoped. */
  organizationId?: string | null;
}

/** GLOBAL vs ORG tenancy badge for roles and policies. */
export function AccessScopeBadge({ organizationId }: AccessScopeBadgeProps) {
  const { t } = useTranslations("settings");
  const isGlobal = !organizationId;
  return (
    <ColocaBadge variant={isGlobal ? "secondary" : "primary"} icon={isGlobal ? Globe : Building2}>
      {isGlobal ? t("access_scope_global") : t("access_scope_org")}
    </ColocaBadge>
  );
}
